<template>
    <!-- 하다희 신규 - 예약현황 -->
    <div class="pop_overlay_black" v-if="isShow">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
                        </circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="pop_wrap rsv_monitor" style="width: 1140px; height: 900px">
            <div class="pop_title">
                <span class="title">{{ $t('reservationwindow.reservationmonitor.label_reservationstat') }}</span>
                <button class="mgl_auto" @click="action_ClosePopup">
                    <v-icon large>mdi-close</v-icon>
                </button>
            </div>
            <ul class="pop_tab_wrap">
                <li :class="{ on: selectedPerType === 'users' }" @click="action_ChangePerType('users')">
                    <a>{{ $t('reservationwindow.reservationmonitor.label_outpatient') }}</a>
                </li>
                <li :class="{ on: selectedPerType === 'managers' }" @click="action_ChangePerType('managers')">
                    <a>{{ $t('reservationwindow.reservationmonitor.label_bystaff') }}</a>
                </li>
                <li :class="{ on: selectedPerType === 'programs' }" @click="action_ChangePerType('programs')">
                    <a>{{ $t('reservationwindow.reservationmonitor.label_byprogram') }}</a>
                </li>
                <li :class="{ on: selectedPerType === 'status' }" @click="action_ChangePerType('status')"><a>{{
                    $t('reservationwindow.reservationmonitor.label_appointmentstatus') }}</a></li>
            </ul>
            <div class="pop_cont">
                <div class="date_wrap">
                    <DateFilter />
                    <button class="btn btn_xxs"
                        :class="{ btn_blue_line: selectedPeriodType === 'day', btn_lgray2: selectedPeriodType !== 'day' }"
                        @click="action_ChangePeriodType('day')">
                        {{ $t('reservationwindow.reservationmonitor.label_daily') }}
                    </button>
                    <button class="btn btn_xxs"
                        :class="{ btn_blue_line: selectedPeriodType === 'week', btn_lgray2: selectedPeriodType !== 'week' }"
                        @click="action_ChangePeriodType('week')">
                        {{ $t('reservationwindow.reservationmonitor.label_weekly') }}
                    </button>
                    <button class="btn btn_xxs"
                        :class="{ btn_blue_line: selectedPeriodType === 'month', btn_lgray2: selectedPeriodType !== 'month' }"
                        @click="action_ChangePeriodType('month')">
                        {{ $t('reservationwindow.reservationmonitor.label_monthly') }}
                    </button>
                </div>
                <hr />
                <div class="top_filter">
                    <div class="group_filter" v-if="isShowGroupFilter">
                        <button class="group_item" :class="{ selected: isSelectedAllGroups }"
                            @click="action_GroupAll">{{ $t('reservationwindow.reservationmonitor.label_all') }}</button>
                        <button v-for="(g, index) in loadedGroups" :key="index"
                            :class="{ selected: selectedGroups.find((group) => group._id == g._id)?.isSelected }"
                            class="group_item" @click="action_Group(g)">
                            {{ g.title }}
                        </button>
                    </div>
                    <div class="mgl_auto" v-if="selectedPerType == 'users'"><b>{{ totalString }} <small>({{
                                totalCountString }})</small>/</b><b class="red_txt">{{ cancelString }}<small>({{
                                cancelCountString }})</small></b></div>
                    <div class="cont_row mgl_auto flex_middle" v-if="selectedPerType !== 'users'">
                        <label class="radio_wrap">
                            <input name="selectedCountType" type="radio" v-model="selectedCountType" value="patients" />
                            <span class="checkmark"></span>
                            {{ $t('reservationwindow.reservationmonitor.radio_patients') }}
                        </label>
                        <label class="radio_wrap">
                            <input name="selectedCountType" type="radio" v-model="selectedCountType"
                                value="reservations" />
                            <span class="checkmark"></span>
                            {{ $t('reservationwindow.reservationmonitor.radio_appointment') }}
                        </label>
                    </div>
                </div>
                <div class="rsv_monitor_graph" v-if="selectedPerType !== 'users'">
                    <ChartPerManagers />
                    <ChartPerPrograms />
                    <ChartPerStatus />
                </div>
                <div class="rsv_monitor_table">
                    <div class="table2_xyscroll sticky w_full">
                        <!-- 내원고객 테이블 -->
                        <ReservationPerUsers :filteredReservation=filteredReservation />

                        <!-- 담당자별 테이블 -->
                        <ReservationPerManagers />

                        <!-- 프로그램 별 테이블 -->
                        <ReservationPerPrograms />

                        <!-- 예약상태별 테이블 -->
                        <ReservationPerStatus />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from '@/util/MPMoment'
import { sheetState } from '../../../sheet-state'
import { closeMonitorPopup, sheetOverlays } from '../../../sheet-overlays'
import { monitorState, updateSelectedPeriod, monitorFilter, selectedGroups, selectedColumns, selectedPrograms, selectedStatus, mergeLocalGroups, mergeLocalColumns, mergeLocalPrograms, mergeLocalStatus, setSelectedGroup } from './monitor-popup-state'
import ChartPerManagers from './ReservationPerManagers/ChartPerManagers.vue'
import ChartPerPrograms from './ReservationPerPrograms/ChartPerPrograms.vue'
import ChartPerStatus from './ReservationPerStatus/ChartPerStatus.vue'
import ReservationPerUsers from './ReservationPerUsers/ReservationPerUsers.vue'
import ReservationPerManagers from './ReservationPerManagers/ReservationPerManagers.vue'
import ReservationPerPrograms from './ReservationPerPrograms/ReservationPerPrograms.vue'
import ReservationPerStatus from './ReservationPerStatus/ReservationPerStatus.vue'
import DateFilter from './DateFilter.vue'

import _ from 'lodash'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2ReservationGroupFindQueryOptions } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-find-query'
import { v2ReservationProgramFindQueryOptions } from '@/composables/queries/v2reservationprogram/use-v2-reservationprogram-find-query'
import { v2ReservationStatusFindQueryOptions } from '@/composables/queries/v2reservationstatus/use-v2-reservationstatus-find-query'
import { v2ReservationListQueryOptions } from '@/composables/queries/v2reservation/use-v2-reservation-list-query'
import { statsV2ReservationDailyFindQueryOptions } from '@/composables/queries/stats/use-stats-v2reservation-daily-find-query'
import { reservationColumnFindQueryOptions } from '@/composables/queries/reservationcolumn/use-reservation-column-find-query'
import { statsV2ReservationDailyFindHospitalQueryOptions } from '@/composables/queries/stats/use-stats-v2reservation-daily-find-hospital-query'
import { statsV2ReservationMonthlyFindQueryOptions } from '@/composables/queries/stats/use-stats-v2reservation-monthly-find-query'
import { statsV2ReservationMonthlyFindHospitalQueryOptions } from '@/composables/queries/stats/use-stats-v2reservation-monthly-find-hospital-query'

export default {
    setup() {
        const queryClient = useQueryClient()
        return { queryClient }
    },
    components: {
        ChartPerManagers: ChartPerManagers,
        ChartPerPrograms: ChartPerPrograms,
        ChartPerStatus: ChartPerStatus,
        ReservationPerUsers: ReservationPerUsers,
        ReservationPerManagers: ReservationPerManagers,
        ReservationPerPrograms: ReservationPerPrograms,
        ReservationPerStatus: ReservationPerStatus,
        DateFilter: DateFilter
    },
    data() {
        return {
            isLoading: false,
            sheetState,
            sheetOverlays,
            monitor: monitorState,
            selectedPerType: 'users', // 내원고객: users 담당자 : managers, 프로그램별: programs, 상태별: status
            selectedCountType: 'patients', // 환자수 : patients, 예약수 : reservations

            columns: [],
            programs: [],
            status: []
        }
    },
    watch: {
        isShow: {
            immediate: true,
            handler: function (newValue) {
                if (newValue === false) {
                    return
                }
                updateSelectedPeriod('day', moment())
                this.selectedPerType = 'users'
                this.selectedCountType = 'patients'
                this.monitor.localGroups = []
                this.monitor.localColumns = []
                this.monitor.localPrograms = []
                this.monitor.localStatus = []
                this.monitor.reservationData = []
                this.loadAllData()
            }
        },
        'monitor.selectedPeriod.startDate': {
            handler: function (newValue) {
                if (newValue === undefined) {
                    return
                }
                this.loadAllData()
            }
        },
        selectedPerType: {
            immediate: true,
            handler: function (newValue) {
                this.monitor.selectedPerType = newValue
            }
        },
        selectedCountType: {
            handler: function (newValue) {
                this.monitor.selectedCountType = newValue
            }
        },
        selectedLocalColumns: {
            // handler: function (newValue, oldValue) {
            handler: function () {
                // if (_.isEqual(newValue, oldValue)) {
                //     return
                // }
                this.refineColumns()
            }
        },
        selectedLocalPrograms: {
            handler: function (newValue, oldValue) {
                if (_.isEqual(newValue, oldValue)) {
                    return
                }
                this.refinePrograms()
            }
        },
        selectedLocalStatus: {
            handler: function (newValue, oldValue) {
                if (_.isEqual(newValue, oldValue)) {
                    return
                }
                this.refineStatus()
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowMonitorPopup
        },
        isShowGroupFilter: function () {
            return this.selectedPerType === 'managers' || this.selectedPerType === 'users'
        },
        selectedPeriodType: function () {
            return this.monitor.selectedPeriod.periodType
        },
        isSelectedAllGroups: function () {
            for (let i = 0; i < this.groups.length; i++) {
                if (this.groups[i].isSelected === false) {
                    return false
                }
            }
            return true
        },
        selectedGroups: function () {
            return this.groups.filter((g) => g.isSelected === true)
        },
        selectedGroupIDs: function () {
            return this.selectedGroups.map(g => g._id)
        },
        filter: function () {
            return monitorFilter()
        },
        // 기간 유형에 따라 일간/월간 통계 쿼리 정의를 선택한다 (레거시 api/patientApi 함수 선택의 대체)
        statsQueryOptions: function () {
            if (this.monitor.selectedPeriod.periodType === 'month') {
                return statsV2ReservationMonthlyFindQueryOptions
            } else {
                return statsV2ReservationDailyFindQueryOptions
            }
        },
        statsHospitalQueryOptions: function () {
            if (this.monitor.selectedPeriod.periodType === 'month') {
                return statsV2ReservationMonthlyFindHospitalQueryOptions
            } else {
                return statsV2ReservationDailyFindHospitalQueryOptions
            }
        },
        apiFilter: function () {
            let hospitalID = this.hospital.selectedHospital._id
            return {
                hospitalID: hospitalID,
                createdAt: {
                    $gte: moment(this.monitor.selectedPeriod.startDate),
                    $lte: moment(this.monitor.selectedPeriod.endDate).endOf('days')
                },
                removedAt: {
                    $gte: moment(this.monitor.selectedPeriod.startDate),
                    $lte: moment(this.monitor.selectedPeriod.endDate).endOf('days')
                }
            }
        },
        loadedGroups: function () {
            return this.monitor.loadedGroups
        },
        groups: function () {
            return this.monitor.localGroups
        },
        selectedLocalColumns: function () {
            return selectedColumns()
        },
        selectedLocalPrograms: function () {
            return selectedPrograms()
        },
        selectedLocalStatus: function () {
            return selectedStatus()
        },
        selectedDate: function () {
            return this.monitor.selectedPeriod.endDate
        },
        palette: function () {
            let reservationSetting = this.sheetState.reservationSetting
            let statusColorPaletteID = reservationSetting?.statusColorPaletteID
            return statusColorPaletteID.basicPalette
        },

        reservationData: function () {
            return this.monitor.reservationData ?? []
        },
        filteredReservation: function () {
            if (this.reservationData == undefined) { return [] }
            let selectedGroupIDs = this.selectedGroupIDs
            let filterFunction = function (data) {
                let isExistGroup = selectedGroupIDs.includes(data.groupID?._id)
                let isNotTest = data.isTest != true

                if (!isExistGroup || !isNotTest) { return false }
                return true
            }

            let columnIDs = this.monitor.loadedColumns.map(c => c._id)
            let programIDs = this.monitor.loadedPrograms.map(p => p._id)
            let datas = this.reservationData.filter(filterFunction)
                .filter(d => columnIDs.includes(d.columnID._id))
                .filter(d => programIDs.includes(d.programID._id))
            return datas.sort((l, r) => {
                let lm = moment(l.startedAt)
                let rm = moment(r.startedAt)
                return lm.isBefore(rm) == true ? 1 : -1
            })
        },
        totalReservationCount: function () {
            return this.filteredReservation?.length ?? 0
        },
        totalUserCount: function () {
            let array = this.filteredReservation
                .map(r => r.hserviceID._id)
                .filter((value, index, self) => self.indexOf(value) === index)
            return array.length
        },
        canceledReservations: function () {
            return this.filteredReservation.filter(r => r.statusID.isCancelStatus == true)
        },
        totalCancelReservationCount: function () {
            return this.canceledReservations.length
        },
        totalCancelUserCount: function () {
            let array = this.canceledReservations
                .map(r => r.hserviceID._id)
                .filter((value, index, self) => self.indexOf(value) === index)
            return array.length
        },
        totalString: function () {
            // <b>총 {{ totalReservationCount }}건 <small>({{ totalUserCount }}명)</small>/</b><b class="red_txt">취소 {{ totalCancelReservationCount }}<small>({{ totalCancelUserCount }}명
            const total = this.$t('reservationwindow.reservationmonitor.label_total')
            return total.replace('{n}', this.totalReservationCount)
        },
        totalCountString: function () {
            const count = this.$t('reservationwindow.reservationmonitor.label_total_count')
            return count.replace('{m}', this.totalUserCount)
        },
        cancelString: function () {
            const cancel = this.$t('reservationwindow.reservationmonitor.label_cancel')
            return cancel.replace('{n}', this.totalCancelReservationCount)
        },
        cancelCountString: function () {
            const count = this.$t('reservationwindow.reservationmonitor.label_cancel_count')
            return count.replace('{m}', this.totalCancelUserCount)
        }
    },
    methods: {
        action_ChangePeriodType(type) {
            let date = moment(this.selectedDate)
            if (type === 'day') {
                date = moment()
            }
            if (type === 'week') {
                date = moment().startOf('week')
            }
            if (type === 'month') {
                date = moment().startOf('month')
            }
            updateSelectedPeriod(type, date)
        },

        action_ChangePerType(type) {
            this.selectedPerType = type
        },

        action_ClosePopup() {
            closeMonitorPopup()
        },

        // MARK: - Group Actions
        action_GroupAll() {
            let isSelected = !this.isSelectedAllGroups
            for (let i = 0; i < this.loadedGroups.length; i++) {
                let g = this.loadedGroups[i]
                setSelectedGroup(g, isSelected)
            }
            this.refineColumns()
        },
        action_Group(group) {
            let isSelected = true
            let index = this.loadedGroups.indexOf(group)
            let g = selectedGroups().find((g) => g._id == group._id)
            if (g === undefined) {
                isSelected = false
            }
            if (index < 0) {
                return
            }
            setSelectedGroup(group, !isSelected)
            this.refineColumns()
        },

        // MARK: - Network
        async loadAllData() {
            this.isLoading = true
            await this.loadGroupData()
            await this.loadColumnData()
            await this.loadPrograms()
            await this.loadRawData()
            await this.loadReservationData()
            await this.loadStatus()
            this.refineColumns()
            this.refinePrograms()
            this.refineStatus()
            this.isLoading = false
        },
        async loadGroupData() {
            let groups
            try {
                groups = await this.queryClient.fetchQuery(v2ReservationGroupFindQueryOptions(this.apiFilter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            let array = groups.map((r) => {
                return {
                    _id: r._id,
                    title: r.title,
                    order: r.sortNum,
                    columns: r.columns,
                    createdAt: r.createdAt,
                    modifiedAt: r.modifiedAt,
                    isRemoved: r.isRemoved,
                    removedAt: r.removedAt,
                    totalProgramCount: 0,
                    isSelected: true
                }
            })
            let unresolvedGroups = array.filter((g) => g.isRemoved === true && g.removedAt !== undefined)
            for (let i = 0; i < unresolvedGroups.length; i++) {
                let item = unresolvedGroups[i]
                let target = array.find((g) => g._id == item._id)
                let index = array.indexOf(target)
                array.splice(index, 1)
            }
            this.monitor.loadedGroups = array
            mergeLocalGroups(array)
        },
        async loadColumnData() {
            let columns
            try {
                columns = await this.queryClient.fetchQuery(reservationColumnFindQueryOptions(this.apiFilter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }

            let array = columns.map((r) => {
                return {
                    _id: r._id,
                    groupID: r.groupID,
                    title: r.title,
                    order: r.sortNum,
                    createdAt: r.createdAt,
                    modifiedAt: r.modifiedAt,
                    isRemoved: r.isRemoved,
                    removedAt: r.removedAt,
                    programs: r.programs,
                    isSelected: true
                }
            })
            const unresolvedColumns = array.filter((g) => g.isRemoved === true && g.removedAt !== undefined)

            for (let i = 0; i < unresolvedColumns.length; i++) {
                const item = unresolvedColumns[i]
                const target = array.find((g) => g._id == item._id)
                const index = array.indexOf(target)

                array.splice(index, 1)
            }
            this.monitor.loadedColumns = array
            mergeLocalColumns(array)
        },
        async loadPrograms() {
            let programs
            try {
                programs = await this.queryClient.fetchQuery(v2ReservationProgramFindQueryOptions(this.apiFilter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            for (let i = 0; i < programs.length; i++) {
                programs[i].isSelected = true
            }
            this.monitor.loadedPrograms = programs
            mergeLocalPrograms(programs)
            this.programs = programs
        },
        async loadStatus() {
            let statusList
            try {
                statusList = await this.queryClient.fetchQuery(v2ReservationStatusFindQueryOptions(this.apiFilter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }
            for (let i = 0; i < statusList.length; i++) {
                statusList[i].isSelected = true
            }
            this.monitor.loadedStatus = statusList
            mergeLocalStatus(statusList)
            this.status = statusList
        },
        async loadRawData() {
            let filter = {
                hospitalID: this.hospital.selectedHospital._id,
                startDate: moment(this.monitor.selectedPeriod.startDate).format(),
                endDate: moment(this.monitor.selectedPeriod.endDate).format()
            }
            if (this.monitor.selectedPerType == 'managers') {
                filter.columnID = []
            }
            try {
                this.monitor.rawData = await this.queryClient.fetchQuery(this.statsQueryOptions(filter))
                this.monitor.totalData = await this.queryClient.fetchQuery(this.statsHospitalQueryOptions(filter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async loadReservationData() {
            let startedAt
            let endedAt
            if (this.selectedPeriodType == 'day') {
                startedAt = moment(this.monitor.selectedPeriod.endDate).startOf('days')
                endedAt = moment(this.monitor.selectedPeriod.endDate).endOf('days')
            }
            else if (this.selectedPeriodType == 'week') {
                startedAt = moment(this.monitor.selectedPeriod.endDate).startOf('weeks')
                endedAt = moment(this.monitor.selectedPeriod.endDate).endOf('weeks')
            }
            else {
                startedAt = moment(this.monitor.selectedPeriod.endDate).startOf('month')
                endedAt = moment(this.monitor.selectedPeriod.endDate).endOf('month')
            }

            let filter = {
                hospitalID: this.hospital.selectedHospital._id,
                startedAt: startedAt.format(),
                endedAt: endedAt.format(),
                isRemoved: false
            }

            try {
                this.monitor.reservationData = await this.queryClient.fetchQuery(v2ReservationListQueryOptions(filter))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 빈 목록
                if (!isApiErrorWithCode(err)) throw err
                this.monitor.reservationData = []
            }
        },

        // MARK: - Data Structure
        refineColumns() {
            let getTotalProgramCount = function (columns) {
                let totalCount = 0
                for (let i = 0; i < columns.length; i++) {
                    if (columns[i].isSelected != true) { continue }
                    totalCount += columns[i].programs?.length ?? 1
                }
                return totalCount
            }
            let getTotalPrograms = function (columns) {
                let array = []
                for (let i = 0; i < columns.length; i++) {
                    let programs = columns[i].programs ?? [{ title: '-' }]
                    array = array.concat(programs)
                }
                return array
            }
            let dateInRange = function (targetDate, start, end) {
                let t = moment(targetDate)
                let s = moment(start)
                let e = moment(end)
                if (t.isSameOrAfter(s) && t.isBefore(e)) {
                    return true
                }
                return false
            }
            let refinedGroups = []
            let refinedColumns = []
            let refinedPrograms = []
            let level0 = []
            let level1 = []
            let level2 = []
            let allColumns = []
            for (let i = 0; i < this.loadedGroups.length; i++) {
                let g = this.loadedGroups[i]
                let og = selectedGroups().find((group) => group._id == g._id)
                if (og === undefined) {
                    continue
                }

                if (g.columns.length > 0) {
                    refinedGroups.push(g)
                }
                let columns = this.monitor.localColumns.filter((c) => c.groupID == g._id)
                g.columns = columns
                allColumns = allColumns.concat(columns)
                let selectedArray = []
                for (let ci = 0; ci < columns.length; ci++) {
                    let c = columns[ci]
                    let id = c._id
                    let oc = this.selectedLocalColumns.find((c) => c._id == id)
                    if (oc === undefined) {
                        continue
                    }
                    selectedArray.push(c)
                }
                if (selectedArray.length === 0) {
                    selectedArray = [{ title: '-' }]
                }
                g.totalProgramCount = getTotalProgramCount(selectedArray)
                refinedColumns = refinedColumns.concat(selectedArray)
                refinedPrograms = refinedPrograms.concat(getTotalPrograms(selectedArray))
            }
            for (let i = 0; i < refinedGroups.length; i++) {
                let g = refinedGroups[i]
                level0.push({
                    title: g.title,
                    colspan: g.totalProgramCount
                })
            }
            for (let i = 0; i < allColumns.length; i++) {
                let c = allColumns[i]
                let oc = this.selectedLocalColumns.find((column) => column._id == c._id)
                if (oc === undefined) {
                    continue
                }
                c.color = this.monitor.colorArray[i % 10]
                level1.push({
                    title: c.title,
                    colspan: c.programs?.length ?? 1,
                    color: c.color
                })
            }
            level2 = refinedPrograms.filter((program) => !!program._id)

            let rawData = this.monitor.rawData
            let refinedValues = []

            for (let i = 0; i < this.monitor.targetDateArray.length; i++) {
                let time = moment(this.monitor.targetDateArray[i])
                let endTime = moment(time)
                if (this.selectedPeriodType === 'day') {
                    endTime = endTime.add(1, 'days')
                }
                if (this.selectedPeriodType === 'week') {
                    endTime = endTime.add(1, 'weeks')
                }
                if (this.selectedPeriodType === 'month') {
                    endTime = endTime.add(1, 'month')
                }
                let row = {
                    time: time,
                    total: {
                        patientCount: 0,
                        reservationCount: 0
                    },
                    values: []
                }
                for (let ci = 0; ci < allColumns.length; ci++) {
                    let c = allColumns[ci]
                    let oc = selectedColumns().find((column) => column._id == c._id)
                    if (oc === undefined) {
                        continue
                    }
                    let programs = c.programs ?? [{ _id: undefined, title: '' }]
                    for (let pi = 0; pi < programs.length; pi++) {
                        let p = programs[pi]
                        let datas = rawData.filter((d) => d.columnID?._id == c._id && d.programID?._id == p._id && dateInRange(d.registerDate, time, endTime))
                        let patientCount = 0
                        let reservationCount = 0
                        for (let di = 0; di < datas.length; di++) {
                            let data = datas[di]
                            patientCount += data.sumHServiceCount
                            reservationCount += data.sumReservationCount
                        }
                        row.total.patientCount += patientCount
                        row.total.reservationCount += reservationCount
                        row.values.push({
                            patientCount: patientCount,
                            reservationCount: reservationCount
                        })
                    }
                }
                refinedValues.push(row)
            }

            this.monitor.tableColumns = {
                headers: {
                    refinedGroups: refinedGroups,
                    refinedColumns: refinedColumns,
                    refinedPrograms: refinedPrograms,
                    level0: level0,
                    level1: level1,
                    level2: level2
                },
                values: refinedValues
            }
        },
        refinePrograms() {
            let dateInRange = function (targetDate, start, end) {
                let t = moment(targetDate)
                let s = moment(start)
                let e = moment(end)
                if (t.isSameOrAfter(s) && t.isBefore(e)) {
                    return true
                }
                return false
            }
            let refinedPrograms = []
            let level0 = []
            let refinedValues = []
            let rawData = this.monitor.rawData
            for (let i = 0; i < this.programs.length; i++) {
                let p = this.programs[i]
                let id = p._id
                let op = this.selectedLocalPrograms.find((p) => p._id == id)
                if (op === undefined) {
                    continue
                }
                p.color = this.monitor.colorArray[i % 10]
                refinedPrograms.push(p)

                level0.push({
                    _id: p._id,
                    title: p.title,
                    color: p.color
                })
            }

            for (let i = 0; i < this.monitor.targetDateArray.length; i++) {
                let time = moment(this.monitor.targetDateArray[i])
                let endTime = moment(time)
                if (this.selectedPeriodType === 'day') {
                    endTime = endTime.add(1, 'days')
                }
                if (this.selectedPeriodType === 'week') {
                    endTime = endTime.add(1, 'weeks')
                }
                if (this.selectedPeriodType === 'month') {
                    endTime = endTime.add(1, 'month')
                }
                let row = {
                    time: time,
                    total: {
                        patientCount: 0,
                        reservationCount: 0
                    },
                    values: []
                }
                for (let pi = 0; pi < refinedPrograms.length; pi++) {
                    let p = refinedPrograms[pi]
                    let datas = rawData.filter((d) => d.programID._id == p._id && dateInRange(d.registerDate, time, endTime))
                    let patientCount = 0
                    let reservationCount = 0
                    for (let di = 0; di < datas.length; di++) {
                        let data = datas[di]
                        patientCount += data.sumHServiceCount
                        reservationCount += data.sumReservationCount
                    }
                    row.total.patientCount += patientCount
                    row.total.reservationCount += reservationCount
                    row.values.push({
                        patientCount: patientCount,
                        reservationCount: reservationCount
                    })
                }
                refinedValues.push(row)
            }
            this.monitor.tablePrograms = {
                headers: {
                    refinedPrograms: refinedPrograms,
                    level0: level0
                },
                values: refinedValues
            }
        },
        refineStatus() {
            let dateInRange = function (targetDate, start, end) {
                let t = moment(targetDate)
                let s = moment(start)
                let e = moment(end)
                if (t.isSameOrAfter(s) && t.isBefore(e)) {
                    return true
                }
                return false
            }

            let refinedStatus = []
            let refinedPrograms = []
            let refinedValues = []
            let level0 = []
            let level1 = []
            let rawData = this.monitor.rawData

            for (let i = 0; i < this.status.length; i++) {
                let stat = this.status[i]
                let os = this.selectedLocalStatus.find((s) => s._id == stat._id)
                if (os === undefined) {
                    continue
                }
                let programs = this.programs
                stat.programs = programs ?? []
                refinedStatus.push(stat)
                refinedPrograms = refinedPrograms.concat(programs)

                let title = stat.title
                let colspan = programs.length
                let color = this.palette[stat.paletteIndex]
                level0.push({
                    title: title,
                    colspan: colspan,
                    color: color
                })
                level1 = level1.concat(programs.map((p) => p.title))
            }

            for (let i = 0; i < this.monitor.targetDateArray.length; i++) {
                let time = moment(this.monitor.targetDateArray[i])
                let endTime = moment(time)
                if (this.selectedPeriodType === 'day') {
                    endTime = endTime.add(1, 'days')
                }
                if (this.selectedPeriodType === 'week') {
                    endTime = endTime.add(1, 'weeks')
                }
                if (this.selectedPeriodType === 'month') {
                    endTime = endTime.add(1, 'month')
                }
                let row = {
                    time: time,
                    total: {
                        patientCount: 0,
                        reservationCount: 0
                    },
                    values: []
                }
                for (let si = 0; si < refinedStatus.length; si++) {
                    let stat = refinedStatus[si]
                    let programs = stat.programs
                    for (let pi = 0; pi < programs.length; pi++) {
                        let p = programs[pi]
                        let datas = rawData.filter((d) => d.statusID?._id == stat._id && d.programID?._id == p._id && dateInRange(d.registerDate, time, endTime))
                        let patientCount = 0
                        let reservationCount = 0
                        for (let di = 0; di < datas.length; di++) {
                            let data = datas[di]
                            if (stat.isCancelStatus == true) {
                                patientCount += data.cancelHServiceCount
                                reservationCount += data.cancelReservationCount
                            }
                            else {
                                patientCount += data.sumHServiceCount
                                reservationCount += data.sumReservationCount
                            }
                        }
                        row.total.patientCount += patientCount
                        row.total.reservationCount += reservationCount
                        row.values.push({
                            patientCount: patientCount,
                            reservationCount: reservationCount
                        })
                    }
                }
                refinedValues.push(row)
            }
            this.monitor.tableStatus = {
                headers: {
                    refinedStatus: refinedStatus,
                    refinedPrograms: refinedPrograms,
                    level0: level0,
                    level1: level1
                },
                values: refinedValues
            }
        }
    }
}
/*
 * Data Structure
 * parsedData: {
 *  columns: {
 *      headers: {
 *          groups: [Object, ...],   // group.isSelected == true
 *          columns: [Object, ...],  // column.isSelected == true -> depends on selected group
 *          level0: [{title: group.title, callspan: Number}, ...],
 *          level1: [{title: column.title, callspan: Number, color: String}, ...],
 *          level2: [{title: program.title}, ...]
 *      },
 *      values: {
 *          timeString: String,
 *          total: {patientCount: Number, reservationCount: Number},
 *          values: [{patientCount: Number, reservationCount: Number}, ...]
 *      }
 *  },
 *  programs: {
 *      headers: {
 *          programs: [Object, ...],
 *          level0: [{title: program.title, color: String}, ...],
 *          level1: [{title: program.title}, ...]
 *      },
 *      values: {
 *          timeString: Object,
 *          total: {patientCount: Number, reservationCount: Number},
 *          values: [{patientCount: Number, reservationCount: Number}, ...]
 *      }
 *  },
 *  status: {
 *      headers: {
 *          status: [Object, ...],
 *          programs: [Object, ...],
 *          level0: [{title: status.title, callspan: Number, color: String}, ...],
 *          level1: [{title: program.title}, ...]
 *      },
 *      values: {
 *          timeString: Object,
 *          total: {patientCount: Number, reservationCount: Number},
 *          values: [{patientCount: Number, reservationCount: Number}, ...]
 *      }
 *  }
 * }
 *
 */
</script>
